import { FlexBox, JoonUIColor } from "@joonapp/web-shared"
import { useEffect, useRef } from "react"
import { useShallow } from "zustand/react/shallow"

import AddQuestButton from "./AddQuestButton"
import AssignedQuests from "./AssignedQuests"
import QuestAISidePanel from "./questAI/QuestAISidePanel"
import QuestBoardMultiSelect from "./QuestBoardMultiSelect"
import QuestBoardUserSelectHeader from "./QuestBoardUserSelectHeader"
import useQuestBoardMultiSelectStore from "./useQuestBoardMultiSelectStore"
import useQuestBoardStore from "./useQuestBoardStore"
import WelcomeQuests from "./WelcomeQuests"
import PageContentWrapper from "../../components/pageContentWrapper/PageContentWrapper"
import PageHeaderWrapper from "../../components/pageHeaderWrapper/PageHeaderWrapper"
import PageWrapper from "../../components/pageWrapper/PageWrapper"
import useDocumentTitle from "../../hooks/useDocumentTitle"
import { requireAuth } from "../../util/auth"
import { localStorageItems } from "../../util/storage"

const QuestBoard = () => {
  useDocumentTitle("Joon - Quests")
  const { showWelcome, setShowWelcome, setQuestBoardRef } = useQuestBoardStore()
  const { isMultiSelectMode } = useQuestBoardMultiSelectStore(
    useShallow((state) => ({
      isMultiSelectMode: state.isMultiSelectMode,
    }))
  )
  // Setting a reference for the top of the quest board
  // so I can scroll to it after quests added
  const qbRef = useRef<HTMLDivElement>(null)
  useEffect(() => setQuestBoardRef(qbRef), [setQuestBoardRef])

  useEffect(() => {
    setShowWelcome(
      !!localStorage.getItem(localStorageItems.needsToSeeWelcomeQuests)
    )
  }, [setShowWelcome])

  if (showWelcome) return <WelcomeQuests />

  return (
    <FlexBox wrap={false}>
      <PageWrapper
        ref={qbRef}
        style={{ background: JoonUIColor.background.xlightGray }}
      >
        {!isMultiSelectMode && (
          <PageHeaderWrapper>
            <QuestBoardUserSelectHeader />
          </PageHeaderWrapper>
        )}
        <PageContentWrapper mobileGutter>
          <AssignedQuests />
          <QuestBoardMultiSelect />
        </PageContentWrapper>
        <AddQuestButton />
      </PageWrapper>
      <QuestAISidePanel />
    </FlexBox>
  )
}

const QuestBoardWithAuth = requireAuth(QuestBoard)
export default QuestBoardWithAuth
